import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, User, ShoppingBag } from "lucide-react";
import { NAV } from "@/lib/constants";
import { useAuth } from "@/lib/auth";
import { useCart } from "@/lib/cart";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const auth = useAuth();
  const cart = useCart();
  if (loc.pathname.startsWith("/admin")) return null;
  const member = auth?.user;
  const count = cart?.count || 0;

  return (
    <header className="sticky top-0 z-50 bg-brand-cream/90 backdrop-blur-md border-b border-brand-linen">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center justify-between h-20">
          <Link to="/" data-testid="nav-logo" className="flex flex-col leading-none">
            <span className="font-serif text-2xl tracking-tight text-brand-charcoal">Agnes Whitmore</span>
            <span className="overline text-[0.6rem] mt-1">Rosewood Cottage</span>
          </Link>
          <nav className="hidden lg:flex items-center gap-6">
            {NAV.slice(0, 7).map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.to.slice(1)}`}
                className="link-underline font-sans text-[0.74rem] uppercase tracking-[0.12em] text-brand-body hover:text-brand-charcoal transition-colors"
              >
                {n.label}
              </Link>
            ))}
            <Link to={member ? "/account" : "/membership"} data-testid="nav-account"
              className="flex items-center gap-2 font-sans text-[0.74rem] uppercase tracking-[0.12em] text-brand-copper hover:text-brand-charcoal transition-colors">
              <User size={15} /> {member ? "Account" : "Join"}
            </Link>
            <button onClick={() => cart?.setOpen(true)} data-testid="nav-cart" aria-label="Basket"
              className="relative flex items-center text-brand-charcoal hover:text-brand-copper transition-colors">
              <ShoppingBag size={19} />
              {count > 0 && <span className="absolute -top-2 -right-2 bg-brand-copper text-brand-cream text-[0.6rem] w-4 h-4 rounded-full flex items-center justify-center">{count}</span>}
            </button>
          </nav>
          <div className="flex items-center gap-4 lg:hidden">
            <button onClick={() => cart?.setOpen(true)} data-testid="nav-cart-mobile" aria-label="Basket" className="relative text-brand-charcoal">
              <ShoppingBag size={20} />
              {count > 0 && <span className="absolute -top-2 -right-2 bg-brand-copper text-brand-cream text-[0.6rem] w-4 h-4 rounded-full flex items-center justify-center">{count}</span>}
            </button>
            <button
              data-testid="nav-menu-toggle"
              className="text-brand-charcoal"
              onClick={() => setOpen(!open)}
              aria-label="Menu"
            >
              {open ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>
      {open && (
        <div className="lg:hidden bg-brand-cream border-t border-brand-linen px-6 py-6 space-y-4" data-testid="mobile-menu">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              onClick={() => setOpen(false)}
              className="block font-sans text-sm uppercase tracking-[0.14em] text-brand-body"
            >
              {n.label}
            </Link>
          ))}
          <Link to={member ? "/account" : "/membership"} onClick={() => setOpen(false)}
            className="block font-sans text-sm uppercase tracking-[0.14em] text-brand-copper">
            {member ? "My Account" : "Become a Member"}
          </Link>
        </div>
      )}
    </header>
  );
};
